import { Maybe } from 'maybe-not';
import SDKMessageBus from '../utility/message-bus';
import { IDict } from '../types/utility';

export type IPlatformRequestBody = IDataRequest | IRouteRequest;

export interface IDataRequest extends IRequest {
    dataType: string;
    dataId?: string;
    params?: IDict<string>;
}

export interface IRouteRequest extends IRequest {
    route: string;
}

export interface IRequest {
    method: 'POST' | 'PUT' | 'DELETE' | 'GET';
    body?: string;
}

interface TectonHTTPV1<T> {
    status: string;
    data: T;
}

export default function requestPlatformData(
    messageBus: SDKMessageBus,
    platformCapabilities: Set<string>
) {
    if (platformCapabilities.has('requestPlatformData-v2')) {
        return function(requestOptions: IPlatformRequestBody): Promise<XMLHttpRequest> {
            return messageBus
                .sendRequest<XMLHttpRequest>(
                    `requestPlatformData-v2`,
                    Maybe.just(JSON.stringify(requestOptions))
                )
                .then(response => {
                    if (200 <= response.value.status && response.value.status < 300) {
                        // positive response for any 2XX series response
                        return response.value;
                    }

                    throw response.value;
                });
        };
    } else if (platformCapabilities.has('requestPlatformData')) {
        return function<T>(requestOptions: IPlatformRequestBody): Promise<T> {
            return messageBus
                .sendRequest<TectonHTTPV1<T>>(
                    `requestPlatformData`,
                    Maybe.just(JSON.stringify(requestOptions))
                )
                .then(response => {
                    if (response.value.status === 'success') {
                        // positive response for any 2XX series response
                        return response.value.data;
                    }

                    throw response.value;
                });
        };
    }
}
